// Returns up to 2-letter initials for a name.
// "Ibrahim Kamba" -> "IK", "Zama" -> "ZA", "User Test" -> "UT".
export function getInitials(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0].slice(0, 2).toUpperCase();
}

// Deterministic soft, dark gold-tinted background derived from the name.
// Muted tones that harmonize with the royal gold-on-black theme (initials stay gold).
const AVATAR_COLORS = [
  "#3B3520", "#2C3A2E", "#22303C", "#382640", "#3B331F",
  "#2E3720", "#3A2E20", "#20353A", "#312340", "#3A2A2A",
  "#26304A", "#403618", "#2A3630", "#3A2438", "#333A22",
];

export function avatarColor(name) {
  const s = (name && typeof name === "string" && name.trim()) || "?";
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}
